<template>
  <div class="examCenter">
    <Header></Header>
    <div class="examCenterContent">
      <div class="wrap">
        <div class="title">考试中心</div>
        <div class="detail" v-if="detail != null">
          <div class="detailTitle">
            <div class="certificateName">
              {{ detail.examPlanName }}
            </div>
            <div class="certificateLevel">{{ detail.subTitle }}考试</div>
          </div>
          <div class="detailList">
            <div
              class="detailItem"
              v-for="(item, index) in detail.examSubjectList"
              :key="index"
              :class="{
                notStarted: item.join == 4,
                inExam: item.join == 2 || item.join == 1,
                close: item.join == 3,
              }"
            >
              <div class="testName">{{ item.examSubjectName }}</div>
              <div class="explain">
                {{ item.subjectDescribe }}
              </div>
              <div class="info">
                <div class="label">考试类型:</div>
                <div class="val">
                  {{ item.subjectType == 1 ? "实操" : "理论" }}
                </div>
              </div>
              <div class="info">
                <div class="label">考试时间:</div>
                <div class="val">
                  {{ item.examTime }}
                </div>
              </div>
              <div class="info">
                <div class="label">考试时长:</div>
                <div class="val">{{ item.examDuration }}分钟</div>
              </div>
              <div
                :class="{
                  btnEnd: item.join == 3,
                  btnWrap: item.join != 3,
                }"
              >
                <el-button
                  v-if="item.join == 1 || item.join == 4"
                  :disabled="item.join == 4"
                  :class="{
                    btnClose: item.join == 4,
                  }"
                  @click="joinTest(item)"
                  >开始考试</el-button
                >
                <el-button v-if="item.join == 2" @click="joinTest(item)"
                  >继续考试</el-button
                >
                <div
                  class="countDown"
                  v-if="item.join == 4 && item.examStartLeftSeconds != null"
                >
                  {{ item.times }}后开始考试
                </div>
                <div
                  class="countDown"
                  v-if="
                    (item.join == 1 || item.join == 2) &&
                    item.examEndLeftSeconds != null
                  "
                >
                  剩余 {{ item.surplusTime }}考试结束
                </div>
                <div v-if="item.join == 3">考试已结束</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="输入考前动态码"
      :visible.sync="codeVisible"
      width="420px"
      top="30vh"
      :close-on-click-modal="false"
    >
      <div class="input">
        <el-input
          v-model="verificationCodes"
          maxlength="6"
          @input="handleInput"
        ></el-input>
        <!-- <input
          v-for="(code, index) in verificationCodes"
          :ref="'inputRef' + index"
          :key="index"
          v-model="verificationCodes[index]"
          @input="handleInput(index, $event)"
          @keydown="handleKeyDown(index, $event)"
          maxlength="1"
          class="verification-input"
        /> -->
      </div>
      <div class="tip">考前动态码有当场监考官发布</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="codeVisible = false">取消</el-button>
        <el-button type="primary" @click="toCheck">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Header from "./components/Headers.vue";
import { examCenterList, subjectCodeCheck } from "@/api/exam";
import to from "await-to";
export default {
  components: {
    Header,
  },
  data() {
    return {
      intervalInstance: null,
      detail: {},
      time: 10,
      verificationCodes: "",
      // verificationCodes: ["", "", "", "", "", ""],
      codeVisible: false,
      activeItem: {},
    };
  },
  beforeDestroy() {
    this.intervalInstance && clearInterval(this.intervalInstance);
  },
  created() {
    this.examCenterListData();
  },
  methods: {
    async examCenterListData() {
      const [res, err] = await to(examCenterList({}));
      if (err) return this.$message.warning(err.msg);
      this.detail = res.data;
      if (this.detail != null && this.detail.examSubjectList.length > 0) {
        clearInterval(this.intervalInstance);
        this.intervalInstance = setInterval(() => {
          this.detail.examSubjectList.map((v) => {
            if (v.examStartLeftSeconds != null) {
              v.examStartLeftSeconds--;
              if (v.examStartLeftSeconds >= 0) {
                this.$set(
                  v,
                  "times",
                  this.formatSecondsValue(v.examStartLeftSeconds)
                );
              } else if (
                v.examStartLeftSeconds < 0 &&
                v.examStartLeftSeconds > -5
              ) {
                // clearInterval(this.intervalInstance);
                this.examCenterListData.bind(this)();
              } else if (v.examStartLeftSeconds < -5) {
                clearInterval(this.intervalInstance);
              }
            }
            if (v.examEndLeftSeconds != null) {
              v.examEndLeftSeconds--;
              if (v.examEndLeftSeconds >= 0) {
                this.$set(
                  v,
                  "surplusTime",
                  this.formatSecondsValue(v.examEndLeftSeconds)
                );
              } else if (
                v.examEndLeftSeconds < 0 &&
                v.examEndLeftSeconds > -5
              ) {
                // clearInterval(this.intervalInstance);
                this.examCenterListData.bind(this)();
              } else if (v.examEndLeftSeconds < -5) {
                clearInterval(this.intervalInstance);
              }
            }
          });
        }, 1000);
      }
    },
    joinTest(item) {
      this.verificationCodes = "";
      this.codeVisible = true;
      this.activeItem = item;
      // this.$nextTick(() => {
      //   this.$refs.inputRef0[0].focus();
      // });
    },
    async toCheck() {
      const [res, err] = await to(
        subjectCodeCheck({
          examSubjectId: this.activeItem.id,
          randomCode: this.verificationCodes,
        })
      );
      if (err) return this.$message.warning(err.msg);
      this.toTest(res.data);
    },
    toTest(t) {
      if (this.activeItem.photoCheckFlag) {
        this.$router.push({
          path: "/faceRecognition",
          query: {
            examPlanId: this.activeItem.planId,
            examSubjectId: this.activeItem.id,
            t,
          },
        });
      } else {
        this.$router.push({
          path: "/exam/testPaper",
          query: {
            examPlanId: this.activeItem.planId,
            examSubjectId: this.activeItem.id,
            t,
          },
        });
      }
    },
    formatSecondsValue(value) {
      var timer;
      if (value > 0) {
        var h =
          Math.floor(value / 3600) < 10
            ? "0" + Math.floor(value / 3600)
            : Math.floor(value / 3600);
        var m =
          Math.floor((value / 60) % 60) < 10
            ? "0" + Math.floor((value / 60) % 60)
            : Math.floor((value / 60) % 60);
        var s =
          Math.floor(value % 60) < 10
            ? "0" + Math.floor(value % 60)
            : Math.floor(value % 60);
        timer = h + ":" + m + ":" + s;
        // return (value = h + ":" + m + ":" + s);
      } else {
        timer = "";
      }
      return timer;
    },
    // handleInput(index, event) {
    //   const value = event.target.value;
    //   this.verificationCodes[index] = value;
    //   // 自动跳到下一个输入框
    //   if (value && index < this.verificationCodes.length - 1) {
    //     const nextInput = event.target.nextElementSibling;
    //     if (nextInput) {
    //       this.$nextTick(() => {
    //         nextInput.focus();
    //       });
    //     }
    //   }

    //   // // 自动删除前面的内容
    //   // if (!value && index > 0) {
    //   //   const prevInput = event.target.previousElementSibling;
    //   //   if (prevInput) {
    //   //     prevInput.focus();
    //   //   }
    //   // }
    // },
    // handleKeyDown(index, event) {
    //   // 处理删除操作
    //   if (event.key === "Backspace" && !event.target.value && index > 0) {
    //     const prevInput = event.target.previousElementSibling;
    //     if (prevInput) {
    //       this.$nextTick(() => {
    //         prevInput.focus();
    //       });
    //     }
    //   }
    // },
    handleInput(value) {
      // 使用正则表达式替换非数字字符
      this.verificationCodes = value.replace(/[^\d]/g, "");
    },
  },
};
</script>

<style scoped lang="scss">
.examCenter {
  background-color: #f5f7fa;
  // height: 100vh;
  min-height: 100vh;
  .examCenterContent {
    width: 1200px;
    margin: 0 auto;
    height: calc(100% - 70px);
    padding: 20px 0 30px;
    box-sizing: border-box;
    .wrap {
      background-color: #fff;
      height: 100%;
    }
    .title {
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      padding-left: 20px;
      line-height: 60px;
      box-sizing: border-box;
      border-bottom: 1px solid #e8ebf2;
    }
    .detail {
      padding: 80px 100px 30px;
      box-sizing: border-box;
      height: calc(100% - 60px);
      .detailTitle {
        text-align: center;
        margin-bottom: 60px;
        .certificateName {
          font-size: 28px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          line-height: 42px;
        }
        .certificateLevel {
          font-size: 18px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          margin-top: 20px;
          line-height: 27px;
        }
      }
      .detailList {
        height: calc(100% - 60px - 89px);
        // height: 500px;
        overflow-y: auto;
        .inExam {
          background: url(../../assets/exam/inExam.png) no-repeat left top;
          background-size: 71px 71px;
        }
        .close {
          background: url(../../assets/exam/Closed.png) no-repeat left top;
          background-size: 71px 71px;
        }
        .notStarted {
          background: url(../../assets/exam/notStarted.png) no-repeat left top;
          background-size: 71px 71px;
        }
        .detailItem {
          &:nth-child(2n) {
            margin-right: 0;
          }
          &:nth-child(1) {
            border: 1px solid #3671bf;
            background-color: #f8fbff;
          }
          position: relative;
          padding: 40px 30px 0;
          box-sizing: border-box;
          width: 460px;
          height: 440px;
          background-color: #fff;
          border-radius: 2px 2px 2px 2px;
          opacity: 1;
          border: 1px solid #e6e6e6;
          float: left;
          margin: 0 70px 40px 0;
          .testName {
            font-size: 24px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #333333;
          }
          .explain {
            font-size: 16px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #808080;
            margin: 14px 0 30px;
            line-height: 24px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }
          .info {
            display: flex;
            font-size: 16px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            margin-bottom: 16px;
            .label {
              color: #808080;
              width: 85px;
            }
            .val {
              color: #333333;
              width: calc(100% - 85px);
              line-height: 26px;
              // margin-left: 20px;
            }
          }
          .btnWrap {
            width: 100%;
            margin-top: 30px;
            display: flex;
            justify-content: space-between;
            .el-button {
              width: 140px;
              background-color: #3671bf;
              color: #fff;
            }
            .countDown {
              font-size: 20px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #ff6c6b;
            }
            .btnClose {
              background-color: #d9d9d9;
            }
          }
          .btnEnd {
            text-align: right;
            font-size: 20px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #979797;
            margin-top: 30px;
          }
        }
      }
    }
  }
  .el-dialog {
    .verification-container {
      display: flex;
    }
    .input .el-input {
      width: 100% !important;
      font-size: 18px;
      ::v-deep input {
        letter-spacing: 1px;
      }
    }
    .verification-input {
      width: 50px;
      height: 50px;
      margin-right: 10px;
      text-align: center;
      font-size: 20px;
      border: 1px solid #ccc;
      border-radius: 5px;
    }

    .verification-input:focus {
      outline: none;
      border-color: #007bff;
      box-shadow: 0 0 5px #007bff;
    }
    .tip {
      padding-top: 10px;
    }
    .el-button {
      font-size: 14px;
      &.el-button--primary {
        background-color: #3671bf;
        border: 1px solid #3671bf;
      }
    }
  }
}
</style>
